/* eslint-disable  @typescript-eslint/no-explicit-any */
import type { PipeMiddlewareElement } from '../../middleware-pipe';
import type { MiddlewarePipeDetails } from '../../models/middleware-pipe-details.model';
import type { SearchTab } from '../../../../components/result-page/search-tab/search-tab';
import { makeLogger } from '../../../../logger/logger';
import {getEnv} from '../../../../components/analytics-reporting/util';
import type { PipeMiddlewareNext } from '../../middleware-pipe';

const { debug } = makeLogger({
  pathToCurrentFile:'utils/middleware-pipe/pipes/cose/res-view-item-list-event.ts',
  loggersList: ['debug']
});

export const resViewItemListEvent: PipeMiddlewareElement<MiddlewarePipeDetails, any> = async (
  details: MiddlewarePipeDetails,
  next: PipeMiddlewareNext<any>,
  middlewareDepth: number,
  middlewareArray: Array<PipeMiddlewareElement<MiddlewarePipeDetails, any>>
): Promise<any> => {
    const searchTab: SearchTab = details.context;
    const response = await next(details);
    const locale = (searchTab.language).toLowerCase() + '_' + (searchTab.country).toUpperCase();

    const products = [];
    response.documents.map((product, index) =>{
        return products.push({
          'item_id' : product?.id,
          'item_name' : product[locale]?.title,
          'item_category' : product[locale]?.category?.CT_CAT,
          'index' : index
        });
    });
    if(products.length > 0 && searchTab?.activeTab !== undefined) {
      details.context.ViewItemListEventEmitter.emit({
        event: 'view_item_list',
        value: response.term,
        country: response.country,
        environment: getEnv(),
        platform: 'se.com',
        activeTab: searchTab?.activeTab,
        ecommerce: {
          items: products
        }
      });
    }
    return new Promise(r => r(response));
};
